<app-view-item
  [class]="class"
  *ngIf="readonly"
  [text]="value"
  [borderless]="borderless"
></app-view-item>
@if (suffixButton && suffixButtonIcon) {
  <nz-input-group [nzSuffix]="suffixIconButton" class="!w-full h-8 pr-0">
    <input
      #input
      *ngIf="!readonly"
      nz-input
      [class]="class"
      [ngModel]="value"
      [maxLength]="maxlength"
      [placeholder]="placeholder"
      [required]="isRequired"
      (ngModelChange)="onModelChange($event)"
      (focus)="onInputFocus($event)"
      (blur)="onBlur($event)"
      [disabled]="disabled"
      [nzAutocomplete]="auto"
      autocorrect="off"
      autocomplete="off"
      spellcheck="false"
      [tabindex]="tabindex"
    />
  </nz-input-group>
<ng-template #suffixIconButton>
  <button nz-button nzType="primary" type="button" (click)="suffixButton.emit()">
    <span nz-icon [nzType]="suffixButtonIcon"></span>
  </button>
</ng-template>
} @else {
  <input
    #input
    *ngIf="!readonly"
    nz-input
    [class]="class"
    [ngModel]="value"
    [maxLength]="maxlength"
    [placeholder]="placeholder"
    [required]="isRequired"
    (ngModelChange)="onModelChange($event)"
    (focus)="onInputFocus($event)"
    (blur)="onBlur($event)"
    [disabled]="disabled"
    [nzAutocomplete]="auto"
    autocorrect="off"
    autocomplete="off"
    spellcheck="false"
    [tabindex]="tabindex"
  />
}
<nz-autocomplete
  [nzDataSource]="autoCompleteData"
  nzBackfill
  #auto
></nz-autocomplete>
